import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { credentialingSettingsEffects } from 'src/app/credentialing/+store/effects';
import { credentialingReducers } from 'src/app/credentialing/+store/reducers';
import { credentialingFeatureKey } from 'src/app/credentialing/+store/selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(credentialingFeatureKey, credentialingReducers),
        EffectsModule.forFeature(credentialingSettingsEffects)
    ]
})
export class CredentialingStoreModule {}
